import React from 'react';

import { StyledSocialMedia } from "../../styledComponents";

import FacebookLogo from '../../images/logos/facebook.svg';
import FacebookLogoW from '../../images/logos/facebook_w.svg';

import TwitterLogo from '../../images/logos/twitter.svg';
import TwitterLogoW from '../../images/logos/twitter_w.svg';

import YTLogo from '../../images/logos/yt.svg';
import YTLogoW from '../../images/logos/yt_w.svg';

import LinkedINLogo from '../../images/logos/lin.svg';
import LinkedINLogoW from '../../images/logos/lin_w.svg';

export const LogoSection = () => (
    <StyledSocialMedia>
        <a href="https://www.facebook.com/FreeConferenceCallCom/"><img src={FacebookLogo} alt="Facebook logo" /></a>
        <a href="https://twitter.com/FreeConfCall"><img src={TwitterLogo} alt="Twitter logo" /></a>
        <a href="https://www.youtube.com/user/freeconf"><img src={YTLogo} alt="Youtube logo" /></a>
        <a href="https://www.linkedin.com/company/freeconferencecall.com"><img src={LinkedINLogo} alt="Linkedin logo" /></a>
    </StyledSocialMedia>
)

export const LogoSectionCTA = () => (
    <StyledSocialMedia>
        <a href="https://www.facebook.com/FreeConferenceCallCom/"><img src={FacebookLogoW} alt="Facebook logo" /></a>
        <a href="https://twitter.com/FreeConfCall"><img src={TwitterLogoW} alt="Twitter logo" /></a>
        <a href="https://www.youtube.com/user/freeconf"><img src={YTLogoW} alt="Youtube logo" /></a>
        <a href="https://www.linkedin.com/company/freeconferencecall.com"><img src={LinkedINLogoW} alt="Linkedin logo" /></a>
    </StyledSocialMedia>
)

export const LogoSectionSmall = () => (
    <StyledSocialMedia small>
        <a href="https://www.facebook.com/FreeConferenceCallCom/"><img src={FacebookLogo} alt="Facebook logo" /></a>
        <a href="https://twitter.com/FreeConfCall"><img src={TwitterLogo} alt="Twitter logo" /></a>
        <a href="https://www.linkedin.com/company/freeconferencecall.com"><img src={LinkedINLogo} alt="Linkedin logo" /></a>
    </StyledSocialMedia>
)